import ApiClient from 'dashboard/api/ApiClient';

class DataSyncLayoutAPI extends ApiClient {
  constructor() {
    super('data_sync_layout', { accountScoped: true });
  }

  getLayout(target) {
    return axios.get(this.url, { params: { target } });
  }

  updateLayout(target, items) {
    return this.update('', { target, items });
  }
}

export default new DataSyncLayoutAPI();


